import { cn } from '../lib/cn';
import { Empty, EmptyContent, EmptyDescription, EmptyHeader, EmptyMedia, EmptyTitle } from './empty';

/** Skeleton-Loader — Tabellen/Cards laden mit Skeletons, nicht Spinnern (§13). */
export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('animate-pulse rounded bg-muted motion-reduce:animate-none', className)}
      {...props}
    />
  );
}

/**
 * Empty-State (§7.5 / §13): Icon + Titel + Beschreibung + optionale Aktion.
 * Nie nur „Keine Daten". Komposition über die shadcn-`Empty`-Primitives.
 */
export function EmptyState({
  icon: Icon,
  title,
  description,
  action,
}: {
  icon: React.ComponentType<{ className?: string }>;
  title: string;
  description?: string;
  action?: React.ReactNode;
}) {
  return (
    <Empty className="py-16">
      <EmptyHeader>
        <EmptyMedia variant="icon">
          <Icon aria-hidden />
        </EmptyMedia>
        <EmptyTitle className="text-md font-medium text-foreground">{title}</EmptyTitle>
        {description && <EmptyDescription>{description}</EmptyDescription>}
      </EmptyHeader>
      {action && <EmptyContent>{action}</EmptyContent>}
    </Empty>
  );
}
